<template>
  <div>
    <b-row align-v="center" class="loader" v-if="is_saving">
        <b-col>
            <b-spinner></b-spinner>
            <br><br>
            <strong>Loading</strong>
        </b-col>
    </b-row>
    <b-row class="bg-white m-0 border">
      <b-col cols="3" class="border-right p-3">
        <b-form @submit.prevent="save">
          <b-form-group
            label="Category Description:"
            description="This field is required"
          >
            <b-form-input
              v-model="form.description"
              type="text"
              required
            ></b-form-input>
          </b-form-group>

          <div class="text-right">
            <router-link to="/manpowers/preference-categories/all">
              <b-button v-if="form.id!=-1" variant="dark" size="sm" class="mr-1">
                <font-awesome-icon icon="chevron-left" /> Back</b-button>
            </router-link>
              <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Save Preference Category</b-button>
          </div>
        </b-form>
      </b-col>
      <b-col class="p-2">
        <b-button type="submit" size="sm" class="float-right mb-2" @click="addPreference()"><font-awesome-icon icon="plus-circle" /> Add Preference</b-button>
        <table class="table border-bottom">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Description</th>
              <th scope="col" class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(preference, index) in form.preferences" v-if="!preference.is_deleted">
            <tr>
              <th scope="row">{{preference.description}}</th>
              <td class="text-center">
                <b-button type="submit" size="sm" variant="info" class="mr-2" @click="updatePreference(index,preference)"><font-awesome-icon icon="edit" /> Edit</b-button>
                <b-button type="submit" size="sm" variant="danger" @click="deletePreference(index)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
              </td>
            </tr>
            </template>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <!-- START OF TOOL MODAL -->
      <b-modal v-model="add_preference_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
              <add-preference-component :preference_form="default_preference_form" :current_preferences="form.preferences"  @savePreference="savePreference" />
      </b-modal>
      <!-- END OF TOOL MODAL -->
  </div>
</template>
<script>
    import AddPreferenceComponent from './AddPreferenceComponent.vue';
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
      mixins:[SwalMixin],
      components: {AddPreferenceComponent,NumberFormatComponent},
      data() {
        return {
          form: {
            id:-1,
            description: '',
            preferences:[]
          },
          form_copy:{},
          default_preference_form: {
            index_id:-1,
            id:-1,
            description: '',
            is_deleted:false,
            preference_designation:null,
            preference_designations:null,
          },
          is_saving:false,
          add_preference_modal:false,
          selected_preference:{},
        }
      },
      watch: {
        form:{
            immediate: true,
            deep:true,
            handler(){
              
            }
        }
      },
      created(){
        this.form_copy=JSON.parse(JSON.stringify(this.form));
        if(typeof this.$route.params.id !== 'undefined')
        this.get();
      },
      methods: {
        get(){
          this.is_saving=true;
          this.axios.get('maintenance/preference_categories/get',{params:{id:this.$route.params.id}}).then(response => {
              this.form.preferences = [];
              this.form.id=response.data.id;
              this.form.description=response.data.description;
              response.data.preferences.forEach((e) => {
                let preference = e;
                preference.is_deleted=false;
                preference.show_details=false;
                this.form.preferences.push(preference);
              });
              this.is_saving=false;
          }).catch(error => console.log(error));
        },
        save(){
          event.preventDefault()
          this.swalConfirmSubmit((data)=>{
              if (data.value) {
                this.is_saving=true;
                this.axios.post('maintenance/preference_categories/save',this.form).then(response => {
                    this.swalTransactionCompleted();
                    this.is_saving=false;
                    if(this.form.id==-1){
                      this.form=JSON.parse(JSON.stringify(this.form_copy));
                    }else{
                      this.get();
                    }
                }).catch(error => {
                    this.swal_transaction_error_data.text = error.response.data;
                    this.swalRequestError();
                    this.is_saving=false;
                });
              }
          });
        },
        addPreference(){
          let form = {
            index_id:-1,
            id:-1,
            description: '',
            is_deleted:false,
            preference_designation:null,
            preference_designations:[]
          }
          this.default_preference_form = form;
          this.add_preference_modal=true;
        },
        updatePreference(index,preference){
          this.default_preference_form = preference;
          this.default_preference_form.index_id = index;
          this.add_preference_modal = true;
        },
        savePreference(preference){
          if(preference.index_id==-1){
            preference.preference_type_id = this.form.id;
            this.form.preferences.push(preference);
          }else{
            this.form.preferences[preference.index_id]=preference;
          }
          
          this.add_preference_modal=false;
        },
        deletePreference(index){
          this.swalConfirmDelete((data)=>{
              if (data.value) {
                this.form.preferences[index].is_deleted = true;
              }
          });
          
        },
        designate(preference){
          this.designation_modal=true;
          this.selected_preference = preference;
        },
        maintenance(preference){
          this.maintenance_modal=true;
          this.selected_preference = preference;
        }
      }
    }
</script>
